import {
  Component,
  OnInit,
  Input,
  Injector,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { AttributeOption } from '@app/shared/interfaces/Attribute';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';
import { AttributeTypesValidValues } from 'src/global-variables';

@Component({
  selector: 'app-attribute-type',
  templateUrl: './attribute-type.component.html',
  styleUrls: ['./attribute-type.component.less'],
})
export class AttributeTypeComponent extends BaseComponent {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Input() record: any;
  @Input() listOfOptions: AttributeOption[] = [];
  @Output() optionsChanged = new EventEmitter();
  types = AttributeTypesValidValues;

  constructor(injector: Injector) {
    super(injector);
  }


  
}
